module.exports = window["Bernie_l10nBundle_lv_LV"];